module.exports = __webpack_public_path__ + "static/media/chiefAccountant-3.0977cde4.png";